import { useEffect } from 'react';
import { isNotNull } from 'utils/tsHelpers';
import { addNegativeToastWithErrorId } from 'modules/toastContainer';
import { useDispatch } from 'react-redux';
import { ErrorObject } from './types';

export const useErrorNotification = (errorObject: ErrorObject | null, reset: () => void) => {
  const dispatch = useDispatch();
  useEffect(() => {
    if (isNotNull(errorObject)) {
      const { error, errorId } = errorObject;
      dispatch(addNegativeToastWithErrorId(error.message, errorId, error));
    }
    return reset;
  }, [errorObject]);
};
